module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_200-8ab659d444166be78d85048b2be78f8e.png";